import React, { useState } from 'react'

import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import { BaseDialog, ConfirmationDialog } from 'components'

const FormActions = ({
  onSubmit,
  onNavigate,
  redirectToHome,
  previousQuestion,
  nextQuestion,
  isSubmitting,
}) => {
  const [discardPreviousDialogOpen, setDiscardPreviousDialogOpen] =
    useState(false)
  const [discardHomeDialogOpen, setDiscardHomeDialogOpen] = useState(false)

  const { handleSubmit, formState, triggerValidation } = useFormContext()
  const { dirtyFields } = formState

  const dirty = [...dirtyFields].some((field) => field !== 'hasJustification')

  const handlePrevious = async () => {
    if (!dirty) return onNavigate(previousQuestion)

    const isValid = await triggerValidation()
    if (!isValid) {
      setDiscardPreviousDialogOpen(true)
      return
    }

    handleSubmit((data) => onSubmit(data, previousQuestion))()
  }

  const handleBack = () => {
    if (!dirty) return redirectToHome()
    setDiscardHomeDialogOpen(true)
  }

  const handleConfirmDiscardPrevious = () => {
    setDiscardPreviousDialogOpen(false)
    onNavigate(previousQuestion)
  }

  const handleConfirmDiscardHome = () => {
    setDiscardHomeDialogOpen(false)
    redirectToHome()
  }

  const handleConfirmSaveAndExit = () => {
    setDiscardHomeDialogOpen(false)
    handleSubmit((data) => onSubmit(data, null))()
  }

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Button
          type="button"
          variant="outlined"
          onClick={handleBack}
          disabled={isSubmitting}
        >
          Voltar
        </Button>
        <Box display="flex" gridGap={8}>
          {previousQuestion && (
            <Button
              type="button"
              variant="outlined"
              onClick={handlePrevious}
              disabled={isSubmitting}
            >
              Anterior
            </Button>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            {nextQuestion ? 'Próxima' : 'Salvar'}
          </Button>
        </Box>
      </Box>

      <ConfirmationDialog
        open={discardPreviousDialogOpen}
        setOpen={setDiscardPreviousDialogOpen}
        text="Há alterações não salvas nesta questão. Se voltar agora, elas serão perdidas."
        textButton="Descartar e voltar"
        textButtonCancel="Continuar editando"
        actionAcceptButton={handleConfirmDiscardPrevious}
        variant="error"
        hiddenIcon
      />
      <BaseDialog
        open={discardHomeDialogOpen}
        setOpen={setDiscardHomeDialogOpen}
        title="Sair da questão"
        dialogSize="sm"
        closeIconButton
        dialogActions={
          <Box
            display="flex"
            justifyContent="flex-end"
            gridGap={8}
            flexWrap="wrap"
            width="100%"
          >
            <Button
              variant="outlined"
              onClick={() => setDiscardHomeDialogOpen(false)}
            >
              Continuar editando
            </Button>
            <Button variant="outlined" onClick={handleConfirmDiscardHome}>
              Descartar e sair
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmSaveAndExit}
            >
              Salvar e sair
            </Button>
          </Box>
        }
      >
        <Typography variant="body1">
          Há alterações não salvas nesta questão. O que deseja fazer?
        </Typography>
      </BaseDialog>
    </>
  )
}

FormActions.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onNavigate: PropTypes.func,
  redirectToHome: PropTypes.func.isRequired,
  previousQuestion: PropTypes.object,
  nextQuestion: PropTypes.object,
}

export default FormActions
